<template>
  <div id="main-content">
    <div class="wrapper">
      <div class="table-agile-info">
        <jm-crumbs/>
        <jm-toolbar customize-field-name="">
        </jm-toolbar>
        <el-form
          :inline="true"
          :model="searchData">
          <el-input placeholder="老师姓名" class="jm-input135" v-model="searchData.truename"/>
          <el-form-item>
            <el-button
              type="primary"
              @click="() => {this.refresh = true;}">查询
            </el-button>
          </el-form-item>
        </el-form>
        <jm-tableList
          url="/index/Teacher/getCountryPagetable"
          :search-data="searchData"
          :refresh.sync="refresh">
          <el-table-column
            slot="lastColumn"
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click="edit(scope)">编辑
              </el-button>
            </template>
          </el-table-column>
        </jm-tableList>
      </div>
    </div>
    <el-dialog
      title="编辑"
      :visible.sync="dlgEditVisible">
      <el-form label-width="100px">
        <el-form-item label="老师姓名：">
          {{ info.truename }}
        </el-form-item>
        <el-form-item label="办理国家：">
          <el-select v-model="info.country_ids" multiple placeholder="请选择">
            <el-option
              v-for="item in dict.country"
              :key="item.id"
              :label="item.value"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dlgEditVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      refresh: false,
      dlgEditVisible: false,
      searchData: {
        truename: ''
      },
      info: {
        userid: 0,
        country_ids: []
      },
      dict: {
        country: {}
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
  },
  computed: {},
  methods: {
    handleEdit() { // 编辑
      this.$http._post({
        url: 'index/Teacher/editTeacherCountry',
        data: this.info,
      }).then((res) => {
        if (res.result === 0) {
          this.$message({
            type: 'success',
            message: '保存成功!'
          });
          this.dlgEditVisible = false;
          this.refresh = true;
        }
      });
    },
    edit(scope) { // 编辑
      this.dlgEditVisible = true;
      this.info = Object.assign(this.info, scope.row);
      console.log(this.info);
    }
  },
  created() {
    this.$http._post({
      url: 'index/Teacher/getDic',
    }).then(({ data }) => {
      console.log(data);
      this.dict = data;
    });
  }
};
</script>
<style scoped>
/*
.el-dialog {
  width: 30%;
  min-width: 450px;
}

.el-form-item {
  overflow: hidden;
  text-overflow: ellipsis;
}
*/
</style>
